<script setup>
defineProps({
    verse:{
        type: Object,
        default: () => {},
    },
    slug: {
        type: String,
        default: '',
    },
    pos:{
        type: String,
        default: '',
    },
    small: {
        type: Boolean,
        default: false,
    },
})

defineEmits([ 'select-section', ])
</script>

<template>
    <component
        :is="small ? 'h4' : 'h3'"
        v-if="(small && verse.subheading) || (!small && verse.heading)"
        :id="slug"
        :class="[
            'anchor_' + verse.id,
            'print_' + verse.verse,
            'scroll-elem',
        ]
        "
        :style="pos"
    >
        <span class="d-sr-only">&#x1;</span>
        <span @click="$emit('select-section')">{{ small ? verse.subheading : verse.heading }}</span>
    </component>
</template>